// UserDialogs.jsx
import UserCreateDialog from "./userCreateDialog";
import UserEditDialog from "./userEditDialog";

export default function UserDialogs({ openDialog, data, closeDialog, onSubmit, onShowSuccess }) {
  switch (openDialog) {
    case "create":
      return <UserCreateDialog onClose={closeDialog} onSubmit={onSubmit} onShowSuccess={onShowSuccess} />;
    case "edit":
      return <UserEditDialog data={data} onClose={closeDialog} onSubmit={onSubmit} onShowSuccess={onShowSuccess} />;
    default:
      return null;
  }
}
